export default __webpack_public_path__ + "static/media/PinSpotHelp.d6b67eea.png";